import { gql } from "@apollo/client";

export const getDowntimeSummaryByFailureTypeCorporateDashboard = gql`
    query getDowntimeSummaryByFailureTypeCorporateDashboard($where: event_failure_code_summary_per_mc_bool_exp) {
        failure_type(where: { event_failure_code_summary_per_mcs: { seconds: { _is_null: false, _gt: 0 } } }) {
            failure_type_id
            name
            color_code
            default_failure_type_translations {
                failure_type_id
                language {
                    language_id
                    name
                    code
                }
                translated_name
            }
            is_location_specific
            failure_codes {
                failure_code_id
                name
            }
            event_failure_code_summary_per_mcs_aggregate(where: $where) {
                aggregate {
                    sum {
                        occurrences
                        seconds
                    }
                }
            }
        }
    }
`;

export const getDowntimeSummaryByFailureCodeCorporateDashboard = gql`
    query getDowntimeSummaryByFailureCodeCorporateDashboard(
        $where: event_failure_code_summary_per_mc_bool_exp
        $failure_type_id: Int!
    ) {
        failure_code(
            where: {
                event_failure_code_summary_per_mcs: { seconds: { _is_null: false, _gt: 0 } }
                failure_type_id: { _eq: $failure_type_id }
            }
        ) {
            failure_code_id
            name
            default_failure_code_translations {
                failure_code_id
                language {
                    language_id
                    name
                    code
                }
                translated_name
            }
            failure_type {
                color_code
            }
            event_failure_code_summary_per_mcs_aggregate(where: $where) {
                aggregate {
                    sum {
                        seconds
                        occurrences
                    }
                }
            }
        }
    }
`;

export const getDowntimeSummaryBySecondaryFailureCodeTotalsCorporateDashboard = gql`
    query getDowntimeSummaryBySecondaryFailureCodeTotalsCorporateDashboard(
        $where: event_secondary_failure_code_summary_totals_per_mc_bool_exp
        $start_date: timestamptz!
        $end_date: timestamptz!
    ) {
        downtimes: get_downtime_summary_totals_by_secondary_failure_code(
            args: { start_date: $start_date, end_date: $end_date }
            where: $where
        ) {
            total_seconds
            total_occurrences
            failure_data: secondary_failure_code {
                failure_code_id
                name
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                        code
                    }
                    translated_name
                }
            }
        }
    }
`;

export const getDowntimeSummarySecondaryFailureCodeMillDashboard = gql`
    query getDowntimeSummarySecondaryFailureCodeMillDashboard(
        $where: event_secondary_failure_code_summary_totals_per_mc_bool_exp
        $start_date: timestamptz!
        $end_date: timestamptz!
    ) {
        downtimes: get_downtime_summary_totals_by_secondary_failure_code(
            args: { start_date: $start_date, end_date: $end_date }
            where: $where
        ) {
            total_seconds
            total_occurrences
            failure_data: secondary_failure_code {
                failure_code_id
                name
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
        }
    }
`;

export const getDowntimeSummaryFailureTypeByMillsCorporateDashboard = gql`
    query getDowntimeSummaryFailureTypeByMillsCorporateDashboard(
        $where: event_failure_type_summary_totals_per_mc_bool_exp
        $start_date: timestamptz!
        $end_date: timestamptz!
        $start_date_trailing_trend: timestamptz!
        $end_date_trailing_trend: timestamptz!
    ) {
        baseDowntimes: get_downtime_summary_totals_by_failure_type(
            args: { start_date: $start_date, end_date: $end_date }
            where: $where
        ) {
            total_seconds
            total_occurrences
            machine_center {
                machine_center_id
                production_line {
                    mill {
                        mill_id
                        name
                    }
                }
            }
            failure_type {
                failure_type_id
                color_code
                name
                default_failure_type_translations {
                    failure_type_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
        }
        trailingTrendDowntimes: get_downtime_summary_totals_by_failure_type(
            args: { start_date: $start_date_trailing_trend, end_date: $end_date_trailing_trend }
            where: $where
        ) {
            total_seconds
            total_occurrences
            machine_center {
                machine_center_id
                production_line {
                    mill {
                        mill_id
                        name
                    }
                }
            }
            failure_type {
                failure_type_id
                color_code
                name
                default_failure_type_translations {
                    failure_type_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
        }
    }
`;

export const getDowntimeSummaryFailureCodeByMillsCorporateDashboard = gql`
    query getDowntimeSummaryFailureCodeByMillsCorporateDashboard(
        $where: event_failure_code_summary_totals_per_mc_bool_exp
        $start_date: timestamptz!
        $end_date: timestamptz!
        $start_date_trailing_trend: timestamptz!
        $end_date_trailing_trend: timestamptz!
    ) {
        baseDowntimes: get_downtime_summary_totals_by_failure_code(
            args: { start_date: $start_date, end_date: $end_date }
            where: $where
        ) {
            total_seconds
            total_occurrences
            machine_center {
                machine_center_id
                production_line {
                    mill {
                        mill_id
                        name
                    }
                }
            }
            failure_data: failure_code {
                failure_code_id
                name
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
        }
        trailingTrendDowntimes: get_downtime_summary_totals_by_failure_code(
            args: { start_date: $start_date_trailing_trend, end_date: $end_date_trailing_trend }
            where: $where
        ) {
            total_seconds
            total_occurrences
            machine_center {
                machine_center_id
                production_line {
                    mill {
                        mill_id
                        name
                    }
                }
            }
            failure_data: failure_code {
                failure_code_id
                name
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
        }
    }
`;

export const getDowntimeSummarySecondaryFailureCodeByMillsCorporateDashboard = gql`
    query getDowntimeSummarySecondaryFailureCodeByMillsCorporateDashboard(
        $where: event_secondary_failure_code_summary_totals_per_mc_bool_exp
        $start_date: timestamptz!
        $end_date: timestamptz!
        $start_date_trailing_trend: timestamptz!
        $end_date_trailing_trend: timestamptz!
    ) {
        baseDowntimes: get_downtime_summary_totals_by_secondary_failure_code(
            args: { start_date: $start_date, end_date: $end_date }
            where: $where
        ) {
            total_seconds
            total_occurrences
            machine_center {
                machine_center_id
                production_line {
                    mill {
                        mill_id
                        name
                    }
                }
            }
            failure_data: secondary_failure_code {
                failure_code_id
                name
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
        }
        trailingTrendDowntimes: get_downtime_summary_totals_by_secondary_failure_code(
            args: { start_date: $start_date_trailing_trend, end_date: $end_date_trailing_trend }
            where: $where
        ) {
            total_seconds
            total_occurrences
            machine_center {
                machine_center_id
                production_line {
                    mill {
                        mill_id
                        name
                    }
                }
            }
            failure_data: secondary_failure_code {
                failure_code_id
                name
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
        }
    }
`;
